import { Pipe, PipeTransform } from '@angular/core';

const CARD_SYMBOLS_COUNT = 16;

@Pipe({
  name: 'cardNumber',
  standalone: true,
})
export class CardNumberPipe implements PipeTransform {
  transform(value: string): string {
    return this.#isCorrectCardNumber(value) ? this.#addSpacesIntoCardNumber(value) : value;
  }

  #isCorrectCardNumber(value: string): boolean {
    return value && value.length === CARD_SYMBOLS_COUNT && typeof +value === 'number';
  }

  #addSpacesIntoCardNumber(value: string): string {
    const splitCardNumberArr = value.match(/.{1,4}/g); // split by 4 symbols

    return splitCardNumberArr.join(' ');
  }
}
